import React, { FC, useMemo, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { MONEY_FORMAT } from 'constants/formats';
import { useAuth } from 'context/auth';
import { CashTotals } from 'pages/Cash/components';
import $createStore from 'utils/create-store-instance';
import { onExporting } from 'utils/exportingExcel';

import { useGetCashFlowTotalQuery } from 'bus/cash';

import { CashItemDeleteModal } from '../../../CashFlow/components';

const CashFlowIncomeBankAccount: FC = () => {
  const history = useHistory();
  const { getClaims }: any = useAuth();
  const { id } = useParams<{ id: string }>();

  const { refetch } = useGetCashFlowTotalQuery(undefined, { refetchOnMountOrArgChange: true });

  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [cashFlowId, setCashFlowId] = useState<number | null>(null);

  const requestDateSource = useMemo(() => {
    return $createStore('/v1/CashFlowIncomeBankAccount', 'cashFlowId');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);

  const refresh = () => {
    refGrid.current?.instance.refresh();
    refetch();
  };

  const goToDetailHandler = ({ data }: any) => {
    if (getClaims(['CanEditIncomeAccount'])) {
      history.push(`/cash-flow/${data.cashFlowId}`);
    }
  };

  return (
    <div className="container-dev">
      {modalIsVisibleDelete && (
        <CashItemDeleteModal
          changeVisible={setModalIsVisibleDelete}
          visible={modalIsVisibleDelete}
          refresh={refresh}
          id={cashFlowId}
        />
      )}

      <AppLayoutTop title="Приход с расчетного счета">
        <ClaimsProvider claimsBlock={['CanCreateIncomeAccount']}>
          <Button width={120} text="Создать" type="default" onClick={() => history.push(`/cash-flow-add/${id}`)} />
        </ClaimsProvider>
      </AppLayoutTop>

      <CashTotals />

      <AppCard>
        <DataGrid
          dataSource={requestDateSource as any}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          onRowDblClick={goToDetailHandler}
          onExporting={onExporting}
        >
          <Export enabled={true} />
          <StateStoring enabled={true} type="localStorage" storageKey="CashFlowIncomeBankAccount" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Column dataField="date" caption="Дата" dataType="date" width={150} />
          <Column dataField="cashFlowItemName" caption="Статья движения ДС" />
          <Column dataField="sum" caption="Сумма" format={MONEY_FORMAT} />
          <Column dataField="comment" caption="Комментарий" />
          <Column
            dataField="actions"
            caption=""
            width={120}
            cellRender={(data) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditIncomeAccount']}>
                  <Button icon="edit" type="default" stylingMode="text" onClick={() => goToDetailHandler(data)} />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteIncomeAccount']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setCashFlowId(data.data.cashFlowId);
                      setModalIsVisibleDelete(true);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default CashFlowIncomeBankAccount;
